import type { Mission } from '../missions.ts'

export const census: Mission = {
  id: "census",
  name: "U.S. Census Bureau",
  short: "Census",
  call: "Census",
  kind: "subagency",
  parent: "doc",
  url: "https://www.census.gov/",
  established: 1902,
  palette: {
    primary: "#112e51",
    secondary: "#2b74b7",
    accent: "#008392",
  },
  colorSource: {
    kind: "site",
    url: "https://www.census.gov/",
  },
  motif: "book",
  mission: {
    text: "The Census Bureau's mission is to serve as the nation’s leading provider of quality data about its people and economy.",
    url: "https://www.census.gov/about/what.html",
  },
  fact: {
    text: "Congress created a permanent Census Office on March 6, 1902, after more than a century of temporary census offices.",
    url: "https://www.census.gov/about/history/bureau-history/agency-history-timeline.html",
  },
  seal: {
    file: "public/seals/census.png",
    source: "https://commons.wikimedia.org/wiki/File:Seal_of_the_United_States_Census_Bureau.svg",
  },
  logo: {
    file: "public/logos/census.svg",
    source: "https://commons.wikimedia.org/wiki/File:US-CensusBureau-Logo.svg",
  },
  identifier: {
    about: "https://www.census.gov/about.html",
    accessibility: "https://www.census.gov/about/policies/section-508.html",
    foia: "https://www.census.gov/about/policies/foia.html",
    noFear: "https://www.census.gov/about/policies/no-fear-act.html",
    oig: "https://www.oig.doc.gov/",
    performance: "https://www.commerce.gov/about/budget-and-performance",
    privacy: "https://www.census.gov/about/policies/privacy.html",
  },
  media: {
    photos: [
      {
        file: "/media/census-headquarters.jpg",
        small: "/media/census-headquarters-sm.jpg",
        alt: "The glass and wood-screened U.S. Census Bureau headquarters in Suitland, Maryland, under a blue sky.",
        title: "U.S. Census Bureau headquarters, Suitland, Maryland",
        creator: "U.S. Census Bureau",
        source: "https://commons.wikimedia.org/wiki/File:Census_Bureau_headquarters,_Suitland,_Maryland,_2007.jpg",
        license: "Public domain (U.S. government work)",
      },
      {
        file: "/media/census-machines-1960.jpg",
        small: "/media/census-machines-1960-sm.jpg",
        alt: "A 1960 black-and-white photo of the FOSDIC film-reading computer, with an operator seated at its console.",
        title: "FOSDIC at Census Bureau headquarters, 1960",
        creator: "U.S. Census Bureau",
        source: "https://commons.wikimedia.org/wiki/File:Early_US_Census_Machines_1960_00091.jpg",
        license: "Public domain (U.S. government work)",
      },
    ],
  },
}
